import { baseActions, BaseActionsProps, baseMutations, baseState, BaseState } from "@/store/modules/helpers/baseState";
import { resetDelayedResetTimeout } from "@/store/modules/helpers/delayedReset";
import { getConfig, klinikenApi } from "@/api";
import cloneDeep from "lodash/cloneDeep";

export type SpelarelagItem = {
    id?: string;
    lag: string;
    trojnummer?: number | null;
    position?: string;
    aktiv_fran: string;
    aktiv_till?: string | null;
};

export type Spelare = {
    id: string;
    patient: string;
    spelarelag: SpelarelagItem[];
    langd?: number | null;
    vikt?: number | null;
    dominerande_fot?: string;
    klubbfattning?: string;
};

type State = BaseState & {
    spelare: Map<Spelare["id"], Spelare>;
};

const getDefaultState = (): State => ({
    spelare: new Map(),
    ...cloneDeep(baseState),
});

const moduleName = "spelare";
const baseUrl = "skreg/spelare/";

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        spelareByPatient:
            (state: State) =>
            ({ patientId }: { patientId: string }) => {
                return [...state.spelare.values()].find((s) => s.patient === patientId) ?? null;
            },
    },

    mutations: {
        ...baseMutations({
            reset: (state: State) => {
                Object.assign(state, getDefaultState());
                resetDelayedResetTimeout({ moduleName });
            },
        }),

        setSpelare: (state: State, spelare: Spelare) => {
            state.spelare = new Map([...state.spelare.entries(), [spelare.id, spelare]]);
        },
    },

    actions: {
        ...baseActions({ moduleName }),

        fetchSpelare: async ({ commit }: BaseActionsProps<State>, { patientId }: { patientId: string }) => {
            try {
                const response = await klinikenApi.get(`${baseUrl}${patientId}`, getConfig({}));
                commit("setSpelare", response.data);
                return response.data;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },

        saveSpelare: async (
            { commit }: BaseActionsProps<State>,
            { spelare }: { spelare: Partial<Spelare> & { patient: string } }
        ) => {
            try {
                const response = await klinikenApi.put(`${baseUrl}${spelare.patient}/`, spelare, getConfig({}));
                commit("setSpelare", response.data);
                return response;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
};
